import { create } from "zustand"

const useTapeTechnicalRequests = create((set) => ({
  technicalRequests: [],
  technicalRequestsCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setTechnicalRequests: (orders) =>
    set({ technicalRequests: orders, technicalRequestsCount: orders.length, loading: false }),
  setLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useTapeTechnicalRequests
